module.exports = __webpack_public_path__ + "img/introducePageTwo_show_one.dd5be0fc.jpg";